import { get } from 'lodash';
import type { Primitive } from 'utility-types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const memoize = <T extends (...args: any[]) => void>(func: T, path: string) => {
  let cache: Primitive;
  return (...args: Parameters<T>) => {
    const newCache = get(args, path);
    if (newCache !== cache) {
      cache = newCache;
      func(...args);
    }
  };
};
